import React from "react";
import Topbar from "./Topbar";

// Temporary stand-in for views being built in later commits (one view per
// commit). Keeps the shell and nav fully navigable during the board review.
export default function Placeholder({ title }) {
  return (
    <>
      <Topbar title={title} />
      <div className="crm-placeholder">
        <h2>{title}</h2>
        <p>This view is coming in the next commit.</p>
      </div>
    </>
  );
}
